import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const SELECTOR = '.testimonials';
const CARD_SELECTOR = '.testimonials-card';
const DESKTOP_QUERY = '(min-width: 768px)';
const MIN_SLIDES_FOR_LOOP = 8;

function buildSlider(root, cards, isDesktop) {
    root.classList.add('swiper', 'testimonials-slider');

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    cards.forEach((card) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.appendChild(card.cloneNode(true));
        wrapper.appendChild(slide);
    });

    if (isDesktop) {
        while (wrapper.children.length < MIN_SLIDES_FOR_LOOP) {
            Array.from(wrapper.children)
                .slice(0, cards.length)
                .forEach((slide) => wrapper.appendChild(slide.cloneNode(true)));
        }
    }

    root.appendChild(wrapper);

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'swiper-button-prev testimonials-slider__arrow';
    prevBtn.setAttribute('aria-label', 'Previous testimonials');

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'swiper-button-next testimonials-slider__arrow';
    nextBtn.setAttribute('aria-label', 'Next testimonials');

    const pagination = document.createElement('div');
    pagination.className = 'swiper-pagination testimonials-slider__pagination';

    root.appendChild(prevBtn);
    root.appendChild(nextBtn);
    root.appendChild(pagination);

    const swiper = new Swiper(root, {
        modules: [Navigation, Pagination, Autoplay, A11y],
        slidesPerView: isDesktop ? 'auto' : 1,
        spaceBetween: isDesktop ? 24 : 16,
        loop: isDesktop,
        loopAdditionalSlides: isDesktop ? 3 : 0,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        grabCursor: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn,
        },
        pagination: {
            el: pagination,
            clickable: true,
        },
    });

    window.addEventListener('load', () => swiper.update(), { once: true });

    return swiper;
}

function destroySlider(root, swiper) {
    if (swiper) swiper.destroy(true, true);
    root.classList.remove('swiper', 'testimonials-slider');
    while (root.firstChild) root.removeChild(root.firstChild);
}

function initSlider(root) {
    if (root.dataset.sliderInit === '1') return;
    root.dataset.sliderInit = '1';

    const originalCards = Array.from(root.querySelectorAll(`:scope > ${CARD_SELECTOR}`));
    if (originalCards.length === 0) return;

    while (root.firstChild) root.removeChild(root.firstChild);

    const mq = window.matchMedia(DESKTOP_QUERY);
    let swiper = buildSlider(root, originalCards, mq.matches);

    const handleChange = (e) => {
        destroySlider(root, swiper);
        swiper = buildSlider(root, originalCards, e.matches);
    };

    if (mq.addEventListener) {
        mq.addEventListener('change', handleChange);
    } else if (mq.addListener) {
        mq.addListener(handleChange);
    }
}

function init() {
    document.querySelectorAll(SELECTOR).forEach(initSlider);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
